import getPages from './getPages'
import { arrayToObject, isEmptyObject } from './utils'

export default function getApp(state) {
    const { config = {}, locale = {}, router = {}, pages = [], deviceType } = state
    const { location } = router
    return {
        config,
        locale,
        location,
        pages: arrayToObject(pages, 'id'),
        titles: config.head?.titles,
        deviceType,
    }
}
